// API und WebSocket URLs basierend auf Umgebung
const isProd = import.meta.env.PROD;
export const API_URL = isProd
    ? import.meta.env.VITE_API_URL || 'https://senior-rommee.erik-reisig.workers.dev'
    : '';
export const WS_URL = isProd
    ? import.meta.env.VITE_WS_URL || 'wss://senior-rommee.erik-reisig.workers.dev'
    : `${window.location.protocol === 'https:' ? 'wss:' : 'ws:'}//${window.location.host}`;
export function getApiUrl(path) {
    return `${API_URL}${path}`;
}
export function getWsUrl(path) {
    return `${WS_URL}${path}`;
}
//# sourceMappingURL=config.js.map